/**
 * Resolve external reference URL for a feed row (Inspect modal + inline link).
 *
 * @param {object | null | undefined} res
 * @returns {string}
 */
export function resolveInspectUrl(res) {
  const details = res?.details && typeof res.details === 'object' ? res.details : {};
  const censysQueryValue =
    typeof details.ip === 'string' && details.ip.trim()
      ? details.ip.trim()
      : typeof details.domain === 'string' && details.domain.trim()
        ? details.domain.trim()
        : '';

  if (typeof details.inspect_url === 'string' && details.inspect_url.trim()) {
    return details.inspect_url.trim();
  }
  if (res?.url === 'https://platform.censys.io' && censysQueryValue) {
    return `https://platform.censys.io/search?q=${encodeURIComponent(censysQueryValue)}`;
  }
  const url = res?.url;
  return typeof url === 'string' && url.trim() && url !== '#' ? url.trim() : '';
}

/**
 * @param {object | null | undefined} res
 * @returns {boolean}
 */
export function hasInfraInspectPayload(res) {
  const details = res?.details && typeof res.details === 'object' ? res.details : {};
  return Boolean(
    details.infra_inspect ||
      res?.source === 'corp_infra_probe' ||
      res?.source === 'email_infra_probe' ||
      res?.ui_bucket === 'email_infrastructure',
  );
}

/**
 * @param {object | null | undefined} res
 * @returns {boolean}
 */
export function canOpenFeedInspect(res) {
  if (!res || res.type === 'cache_meta') return false;
  if (hasInfraInspectPayload(res)) return true;
  if (resolveInspectUrl(res)) return true;
  if (res.snippet || res.title || res.details) return true;
  return false;
}

/**
 * Collect supplemental links for the generic inspect modal.
 *
 * @param {object} res
 * @returns {{ label: string, url: string }[]}
 */
export function collectSupplementalInspectLinks(res) {
  const links = [];
  const details = res?.details && typeof res.details === 'object' ? res.details : {};
  const push = (label, url) => {
    const href = String(url || '').trim();
    if (!href || href === '#') return;
    if (links.some((item) => item.url === href)) return;
    links.push({ label, url: href });
  };

  push('Primary source', resolveInspectUrl(res));
  push('Record URL', res?.url);

  if (res?.ui_bucket === 'relationship_node') push('Profile', res.url);
  if (res?.ui_bucket === 'ubo_network') push('Connection', res.url);

  const breaches = Array.isArray(details) ? details : Array.isArray(details?.breaches) ? details.breaches : null;
  if (Array.isArray(breaches)) {
    breaches.slice(0, 6).forEach((breach) => {
      const name = breach?.name || breach?.title;
      if (name) push(`Breach: ${name}`, `https://haveibeenpwned.com/Breach/${encodeURIComponent(name)}`);
    });
  }

  return links;
}
